'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M732.458 3.542l-572.458 572.458-160 448 447.666-160 572.792-572.458c32-128-160-320-288-288zM288 704l-64-64 544-544 64 64-544 544z' })
    ));
};